import { render, staticRenderFns } from "./perfil.vue?vue&type=template&id=7233e9a2&scoped=true"
import script from "./perfil.vue?vue&type=script&lang=ts"
export * from "./perfil.vue?vue&type=script&lang=ts"
import style0 from "./perfil.vue?vue&type=style&index=0&id=7233e9a2&prod&lang=scss"
import style1 from "./perfil.vue?vue&type=style&index=1&id=7233e9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7233e9a2",
  null
  
)

export default component.exports